
import { Box, Typography, Card, Button, Grid, Modal, Stack, Divider, InputLabel, CircularProgress, Autocomplete } from "@mui/material";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SendIcon from "@mui/icons-material/Send";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { styles } from "../../styles/styles";
import { IconButton, Menu, MenuItem, Accordion, AccordionSummary, AccordionDetails, Select, List, ListItem, ListItemText } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { matrimoneyEndPoints } from "../../../services/apis";
import CloseIcon from '@mui/icons-material/Close';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { showError, showSuccess } from "./sweetAlert/sweetAlert";
import { useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { heightToInches } from "../../../utils/heightToInches";
import { FontStyles } from "../../styles/FontStyles";
import CustomPagination from "./pagination";
import { StyledFormControl, StyledTextField } from "../../common/FormStyles";
import { ageOptions } from "../Authentication/PartnerPrefrencesForm";
import Advance from "./AdvancedSearch"
import { bloodGroups, complexions, drinkOptions, foodPreferences, heightOptions, khujaDhoshamOptions, maritalStatuses, padams, smokeOptions } from "../Authentication/PersonalDetailsForm";
import {
  getCitiessListByDistrict,
  getProfileDetails,
  getCountriesList, getDesignationList, getDistrictsListByState, getEmployedInList, getFamilyStatusList, getFamilyTypeList, getHealthConditionList, getMoonsignList, getMotherTongueList, getProfessionList, getStarList, getStatesList, getStatesListByCountry
} from "../../../services/operations/userOperations";
const maritalStatusOptions = [
  { label: "Unmarried", value: "Unmarried" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widowed", value: "Widowed" }
];

const ProfileCategories = ({ onSearchComplete }) => {

  const [profileData, setProfileData] = useState([])
  const [profileImages, setProfileImages] = useState([])
  const [searchPerams] = useSearchParams()
  const profile = localStorage.getItem("profileData");
  const storedProfileData = JSON.parse(profile)
  const [interestsCount, setInterestsCount] = useState({})
  const [profilesCount, setProfilesCount] = useState({})
  const type = searchPerams.get('type')
  let userType = sessionStorage.getItem("userType")
  let token
  if (userType) {
    token = sessionStorage.getItem("token");
  } else {
    token = localStorage.getItem("token");
  }
  const [label, setLabel] = useState(type == "interests" ? "Interest Sent" : "Shortlisted Profiles")
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [spinner, setSpinner] = useState(false)
  let apiCall = useRef(false)
  const [totalCount, setTotalCount] = useState(0)
  const getCustomerData = async (url, payload = {}) => {
    try {
      setSpinner(true)
      const response = await axios.post(
        url,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setProfileData(response.data?.data);
        setSpinner(false)
        setTotalCount(response.data?.totalCount)
      } else {
        setProfileData([])
        setSpinner(false)
        setTotalCount(0)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };

  const getCustomerCountData = async (url) => {
    try {
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setInterestsCount(response.data?.data)
      } else {
        setInterestsCount({})
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };

  const getUploadedImages = async () => {

    try {
      const response = await axios.post(
        matrimoneyEndPoints.GET_UPLOAD_IMAGES,
        { "profileId": storedProfileData?.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setProfileImages(response.data?.data);
      } else {
        setProfileImages([])
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };

  const getCustomerProfileCountData = async (url) => {
    try {
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setProfilesCount(response.data?.data)
      } else {
        setProfilesCount({})
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };
  // useEffect(() => {
  //   apiCall.current = false;
  // }, [type]);


  const staticDataFetched = useRef(false);

  // Run only once for static API calls
  useEffect(() => {
    if (staticDataFetched.current) return;

    const fetchStaticData = async () => {
      try {
        const [
          star,
          moon,
          tongue,
          health,
          country,
          emp,
          prof,
          desig,
          states,
          famStatus,
          famType
        ] = await Promise.all([
          getStarList(),
          getMoonsignList(),
          getMotherTongueList(),
          getHealthConditionList(),
          getCountriesList(),
          getEmployedInList(),
          getProfessionList(),
          getDesignationList(),
          getStatesList(1),
          getFamilyStatusList(),
          getFamilyTypeList()
        ]);

        if (star.status) setStars(star.data);
        if (moon.status) setMoonsigns(moon.data);
        if (tongue.status) setMotherTongue(tongue.data);
        if (health.status) setHelthCondition(health.data);
        if (country.status) setCountryOptions(country.data);
        if (emp.status) setEmployedInOptions(emp.data);
        if (prof.status) setProfessionOptions(prof.data);
        if (desig.status) setDesignationOptions(desig.data);
        if (states.status) setWorkingStatesOption(states.data);
        if (famStatus.status) setFamilyStatusOptions(famStatus.data);
        if (famType.status) setFamilyTypeOptions(famType.data);

        staticDataFetched.current = true;
      } catch (error) {
        console.error("Static API error", error);
      }
    };

    fetchStaticData();
  }, []);

  // Run every time `type` changes
  useEffect(() => {
    const customerPayload = { input_skip: 0, input_limit: 10 };

    setLabel(type === "interests" ? "Interest Sent" : "Shortlisted Profiles");
    setSelectedIndex(0);

    if (type === "my-album") {
      getUploadedImages();
    } else if (type === "interests") {
      getCustomerData(matrimoneyEndPoints.INTEREST_SENT_PROFILES_LIST, { skip: 0, limit: 10 });
      getCustomerCountData(matrimoneyEndPoints.INTEREST_COUNTS);
    } else if (type === "profiles") {
      getCustomerData(matrimoneyEndPoints.SHORT_LISTED_PROFILE, { skip: 0, limit: 10 });
      getCustomerProfileCountData(matrimoneyEndPoints.PROFILE_COUNTS);
    } else if (type === "suggested-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_SUGGESTED_PROFILES, customerPayload, { skip: 0, limit: 10 });
    } else if (type === "verified-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_VERIFIED_PROFILES, customerPayload, { skip: 0, limit: 10 });
    }
    setCurrentPage(1);
  }, [type]);


  let getProfileRelatedData = async (url, payload) => {
    const response = await axios.post(
      url,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.status) {
      setProfileData(response.data?.data);
      setTotalCount(response.data?.totalCount)

    } else {
      setProfileData({
        status: false,
        data: []
      });
      setTotalCount(0)
    }
  }
  const filterInterestsAndProfileData = async (index, label) => {
    setSelectedIndex(index)
    setLabel(label)
    try {
      let url
      if (label == "Shortlisted Profiles") {
        url = matrimoneyEndPoints.SHORT_LISTED_PROFILE
      } else if (label == "Blocklisted Profiles") {
        url = matrimoneyEndPoints.BLOCK_LISTED_PROFILE
      } else if (label == "Profiles I Viewed") {
        url = matrimoneyEndPoints.PROFILES_I_VIEWED
      } else if (label == "Viewed My Profile") {
        url = matrimoneyEndPoints.VIEWED_MY_PROFILE
      } else if (label == "Interest Sent") {
        url = matrimoneyEndPoints.INTEREST_SENT_PROFILES_LIST
      } else if (label == "Interest Viewed") {
        url = matrimoneyEndPoints.INTEREST_VIEWED_PROFILES_LIST
      } else if (label == "Interest Accepted") {
        url = matrimoneyEndPoints.INTEREST_ACCEPTED_PROFILES_LIST
      } else if (label == "Interest Received") {
        url = matrimoneyEndPoints.INTEREST_RECEIVED_PROFILES_LIST
      } else if (label == "Interest Ignored") {
        url = matrimoneyEndPoints.INTEREST_IGNORED_PROFILES_LIST
      } else if (label == "Interest Pending") {
        url = matrimoneyEndPoints.INTEREST_PENDING_PROFILES_LIST
      }
      await getProfileRelatedData(url, { skip: 0, limit: 10 })

    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }
  const [selectedProfile, setSelectedProfile] = useState({ id: 1, name: "Verified Profiles", count: "10", color: "#d89a5d" });
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [fromAge, setFromAge] = useState(18);
  const [toAge, setToAge] = useState(24);
  // const [selectedAge, setSelectedAge] = useState("18 yrs - 24 yrs");
  const [selectedAge, setSelectedAge] = useState();

  const handleOnclick = (e) => {
    setSelectedProfile(null);
  }
  const handleFromAgeChange = (event) => {
    const newFromAge = event.target.value;

    // Ensure From Age is less than To Age
    if (newFromAge >= toAge) {
      const nextToAge = newFromAge + 1;
      setToAge(nextToAge);
      setSelectedAge({ from: newFromAge, to: nextToAge });
    } else {
      setSelectedAge({ from: newFromAge, to: toAge });
    }

    setFromAge(newFromAge);
  };

  const handleToAgeChange = (event) => {
    const newToAge = event.target.value;

    // Ensure To Age is greater than From Age
    if (newToAge <= fromAge) {
      const prevFromAge = newToAge - 1;
      setFromAge(prevFromAge);
      setSelectedAge({ from: prevFromAge, to: newToAge });
    } else {
      setSelectedAge({ from: fromAge, to: newToAge });
    }

    setToAge(newToAge);
  };

  const [popupHeight, setPopupHeight] = useState(false);
  const [fromHeight, setFromHeight] = useState("4’6”");
  const [toHeight, setToHeight] = useState("5’6”");
  // const [selectedHeight, setSelectedHeight] = useState("4’6” - 5’6”");
  const [selectedHeight, setSelectedHeight] = useState({ from: "4'6", to: "5'6" });
  // const heightOptions = [
  //   "4’6”", "5’0”", "5’6”", "6’0”", "6’6”"
  // ];
  const handleFromHeightChange = (event) => {
    const newFrom = event.target.value;
    setFromHeight(newFrom);

    if (heightToInches(newFrom) >= heightToInches(toHeight)) {
      // auto-fix To Height to next option
      const nextIndex = heightOptions.findIndex(h => h === newFrom) + 1;
      const nextTo = heightOptions[nextIndex] || newFrom;

      setToHeight(nextTo);
      setSelectedHeight({ from: newFrom, to: nextTo });
    } else {
      setSelectedHeight({ from: newFrom, to: toHeight });
    }
  };

  const handleToHeightChange = (event) => {
    const newTo = event.target.value;
    setToHeight(newTo);

    if (heightToInches(newTo) <= heightToInches(fromHeight)) {
      // auto-fix From Height to previous option
      const prevIndex = heightOptions.findIndex(h => h === newTo) - 1;
      const prevFrom = heightOptions[prevIndex] || newTo;

      setFromHeight(prevFrom);
      setSelectedHeight({ from: prevFrom, to: newTo });
    } else {
      setSelectedHeight({ from: fromHeight, to: newTo });
    }
  };


  const [Profile, setProfile] = useState('');
  const [popupProfile, setPopupProfile] = useState(false);
  const handlechangeProfile = (e) => {
    setProfile(e.target.value)
  }
  const [marital, setMarital] = useState('');
  const [popupMarital, setPopupMarital] = useState(false);
  const onChangeMarital = (e) => {
    setMarital(e.target.value)
  }

  const [language, setLanguage] = useState("");
  const [popupLanguage, setPopupLanguage] = useState(false);
  const onchangeLanguage = (e) => {
    setLanguage(e.target.value);
  }
  const [physical, setPhysical] = useState("");
  const [popupPhysical, setPopupPhysical] = useState(false);
  const onChange = (e) => {
    setPhysical(e.target.value);
  }
  const itemsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = async (page) => {
    if (type === "suggested-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_SUGGESTED_PROFILES, { "input_skip": (page - 1) * 10, "input_limit": page * 10 });
    } else if (type === "verified-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_VERIFIED_PROFILES, { "input_skip": (page - 1) * 10, "input_limit": page * 10 });
    } else {
      let url
      if (label == "Shortlisted Profiles") {
        url = matrimoneyEndPoints.SHORT_LISTED_PROFILE
      } else if (label == "Blocklisted Profiles") {
        url = matrimoneyEndPoints.BLOCK_LISTED_PROFILE
      } else if (label == "Profiles I Viewed") {
        url = matrimoneyEndPoints.PROFILES_I_VIEWED
      } else if (label == "Viewed My Profile") {
        url = matrimoneyEndPoints.VIEWED_MY_PROFILE
      } else if (label == "Interest Sent") {
        url = matrimoneyEndPoints.INTEREST_SENT_PROFILES_LIST
      } else if (label == "Interest Viewed") {
        url = matrimoneyEndPoints.INTEREST_VIEWED_PROFILES_LIST
      } else if (label == "Interest Accepted") {
        url = matrimoneyEndPoints.INTEREST_ACCEPTED_PROFILES_LIST
      } else if (label == "Interest Received") {
        url = matrimoneyEndPoints.INTEREST_RECEIVED_PROFILES_LIST
      } else if (label == "Interest Ignored") {
        url = matrimoneyEndPoints.INTEREST_IGNORED_PROFILES_LIST
      } else if (label == "Interest Pending") {
        url = matrimoneyEndPoints.INTEREST_PENDING_PROFILES_LIST
      }
      await getProfileRelatedData(url, { skip: (page - 1) * 10, limit: page * 10 })
    }
    setCurrentPage(page);
  };

  // Slice data for current page (client-side pagination)
  // const displayedCustomers = allCustomers.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  const [UserFilters, setFilters] = useState({
    age: "",
    height: "",
    marital: "",
    language: "",
    physical: "",
    profile: "",
  });

  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setFiles([]);
    setOpen(false);
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (selectedFiles.length + files.length > 5) {
      alert("You can upload a maximum of 5 images.");
      return;
    }
    setFiles([...files, ...selectedFiles]);
  };
  const [uploadImagesMsg, setUploadImagesMsg] = useState({
    status: false,
    message: "",
    isSuccess: false
  })
  const [blockeviewhide, setBlockeViewHide] = useState(false);
  const handlechangeBlcok = () => {
    setBlockeViewHide(false)
  }
  const handleUpload = async () => {
    // Your upload logic here
    if (files.length > 0) {
      let formData = new FormData()
      files.forEach((file) => {
        formData.append('images', file); // Append each file individually
      });
      try {
        const response = await axios.post(
          matrimoneyEndPoints.UPLOAD_PROFILE_PICS,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status) {
          setUploadImagesMsg({
            status: true,
            message: "Images Uploaded Successfully",
            isSuccess: true
          })
          setTimeout(() => {
            handleClose();
            window.location.reload()
          }, 2000)

        } else {
          setUploadImagesMsg({
            status: true,
            message: response?.data?.message,
            isSuccess: false
          })
        }
      } catch (error) {
        console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
      }
    }
  };



  let UpcomingProfiles = {
    fromAge: '',
    toAge: '',
    fromHeight: '',
    toHeight: '',
    padam: '',
    birthPlace: '',
    star: '',
    moonsign: '',
    gothram: '',
    khujaDhosham: '',
    bloodGroup: '',
    motherTongue: '',
    helthCondition: '',
    complexion: '',
    maritalStatus: '',
    smoke: '',
    drink: '',
    food: '',
    passport: '',
    country: '',
    state: '',
    district: '',
    city: '',
    employedIn: '',
    profession: '',
    designation: '',
    workLocation: '',
    workingCountry: '',
    workingState: '',
    totalExperience: '',
    annalIncome: '',
    familyStatus: '',
    familyType: ''
  };



  const [filterOptions, setFilterOptions] = useState(UpcomingProfiles)

  const [stars, setStars] = useState([])
  const [moonsigns, setMoonsigns] = useState([])
  const [motherTongue, setMotherTongue] = useState([])
  const [helthCondition, setHelthCondition] = useState([])
  const [countryOptions, setCountryOptions] = useState([])
  const [stateOptions, setStateOptions] = useState([])
  const [districtOptions, setDistrictOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
  const [employedInOptions, setEmployedInOptions] = useState([])
  const [professionOptions, setProfessionOptions] = useState([])
  const [designationOptions, setDesignationOptions] = useState([])
  const [workingStateOptions, setWorkingStatesOption] = useState([])
  const [familyStatusOptions, setFamilyStatusOptions] = useState([])
  const [familyTypeOptions, setFamilyTypeOptions] = useState([])

  // useEffect(() => {
  //   const getApiOptions = async () => {

  //     const response = await getStarList();
  //     if (response.status) {
  //       setStars(response.data);
  //     }
  //     const moonsignResponse = await getMoonsignList()
  //     if (moonsignResponse.status) {
  //       setMoonsigns(moonsignResponse.data);
  //     }
  //     const motherTongueResponse = await getMotherTongueList();
  //     if (motherTongueResponse.status) {
  //       setMotherTongue(motherTongueResponse.data);
  //     }
  //     const helthCondition = await getHealthConditionList()
  //     if (helthCondition.status) {
  //       setHelthCondition(helthCondition.data);
  //     }
  //     const countryResponse = await getCountriesList()
  //     if (countryResponse.status) {
  //       setCountryOptions(countryResponse.data);
  //     }
  //     const employedInResponse = await getEmployedInList()
  //     if (employedInResponse.status) {
  //       setEmployedInOptions(employedInResponse.data);
  //     }
  //     const professionResponse = await getProfessionList();
  //     if (professionResponse.status) {
  //       setProfessionOptions(professionResponse.data);
  //     }
  //     const designationResponse = await getDesignationList();
  //     if (designationResponse.status) {
  //       setDesignationOptions(designationResponse.data);
  //     }
  //     const statesResponse = await getStatesList(1); // Pass countryId 1 for India
  //     if (statesResponse.status) {
  //       setWorkingStatesOption(statesResponse.data);
  //     }
  //     const familyStatusResponse = await getFamilyStatusList(); // Pass countryId 1 for India
  //     if (familyStatusResponse.status) {
  //       setFamilyStatusOptions(familyStatusResponse.data);
  //     }
  //     const familyTypeResponse = await getFamilyTypeList(); // Pass countryId 1 for India
  //     if (familyTypeResponse.status) {
  //       setFamilyTypeOptions(familyTypeResponse.data);
  //     }


  //   };

  //   getApiOptions();
  // }, []);
  const handleSearcch = () => {
    let rawPayload = {
      input_from_age: filterOptions.fromAge ? Number(filterOptions.fromAge?.id) : "",
      input_to_age: filterOptions.toAge ? Number(filterOptions.toAge?.id) : "",
      input_from_height: filterOptions.fromHeight ? Number(filterOptions.fromHeight?.id) : "",
      input_to_height: filterOptions.toHeight ? Number(filterOptions.toHeight?.id) : "",
      input_padam: filterOptions.padam ? Number(filterOptions.padam?.id) : "",
      input_birthplace: filterOptions.birthPlace ? filterOptions.birthPlace : "",
      input_star: filterOptions.star ? Number(filterOptions.star?.id) : "",
      input_moonsign: filterOptions.moonsign ? Number(filterOptions.moonsign?.id) : "",
      input_gothram: filterOptions.gothram ? filterOptions.gothram : "",
      input_khuja_Dosham: filterOptions.khujaDhosham ? filterOptions.khujaDhosham?.id : "",
      input_blood_group: filterOptions.bloodGroup ? filterOptions.bloodGroup?.id : "",
      input_mother_tongue: filterOptions.motherTongue ? Number(filterOptions.motherTongue?.id) : "",
      input_health_condition: filterOptions.helthCondition ? Number(filterOptions.helthCondition?.id) : "",
      input_complexion: filterOptions.complexion ? filterOptions.complexion?.id : "",
      input_marital_status: filterOptions.maritalStatus ? filterOptions.maritalStatus?.id : "",
      input_smoke: filterOptions.smoke ? filterOptions.smoke?.id : "",
      input_drink: filterOptions.drink ? filterOptions.drink?.id : "",
      input_diet: filterOptions.food ? filterOptions.food?.id : "",
      input_passport: filterOptions.passport ? filterOptions.passport?.id : "",
      input_country: filterOptions.country ? Number(filterOptions.country?.id) : "",
      input_state: filterOptions.state ? Number(filterOptions.state?.id) : "",
      input_district: filterOptions.district ? Number(filterOptions.district?.id) : "",
      input_city: filterOptions.city ? Number(filterOptions.city?.id) : "",
      input_employe_in: filterOptions.employedIn ? Number(filterOptions.employedIn?.id) : "",
      input_profession: filterOptions.profession ? Number(filterOptions.profession?.id) : "",
      input_designation: filterOptions.designation ? Number(filterOptions.designation?.id) : "",
      input_worklocation: filterOptions.workLocation ? Number(filterOptions.workLocation?.id) : "",
      input_workingstate: filterOptions.workingState ? Number(filterOptions.workingState?.id) : "",
      input_total_experince: filterOptions.totalExperience ? filterOptions.totalExperience : "",
      input_annual_income: filterOptions.annalIncome ? Number(filterOptions.annalIncome) : "",
      input_familytype: filterOptions.familyType ? Number(filterOptions.familyType?.id) : "",
      input_familystatus: filterOptions.familyStatus ? Number(filterOptions.familyStatus?.id) : "",
      input_skip: 0,
      input_limit: 10
    };

    const payload = Object.entries(rawPayload).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = typeof value === "string" || typeof value === "number" ? value : Number(value);
      }
      return acc;
    }, {});
    if (type === "suggested-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_SUGGESTED_PROFILES, payload);
    } else if (type === "verified-profiles") {
      getCustomerData(matrimoneyEndPoints.GET_CUSTOMER_VERIFIED_PROFILES, payload);
    }
  }
  const handleSelectChange = async (field, newValue) => {

    if (field == "workLocation" && newValue?.id == "india") {
      const response = await getStatesList(1);
      if (response.status) {
        setWorkingStatesOption(response.data);
      }
    }
    if (field == "workingCountry") {
      const response = await getStatesListByCountry(newValue.id)
      if (response.status) {
        setWorkingStatesOption(response.data);
      }
    }
    if (field == "country") {
      const response = await getStatesListByCountry(newValue.id)
      if (response.status) {
        setStateOptions(response.data);
      }
    }
    if (field == "state") {
      const response = await getDistrictsListByState(newValue.id)
      if (response.status) {
        setDistrictOptions(response.data);
      }
    }
    if (field == "district") {
      const response = await getCitiessListByDistrict(newValue.id)
      if (response.status) {
        setCityOptions(response.data);
      }
    }
    setFilterOptions((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFilterOptions((prev) => ({
      ...prev,
      [name]: value,
    }));
  };




  const CommunityProfileOptions = useMemo(() => {
    return [
      { Personal: [] },
      { Education: [] },
      { Family: [] },
      // {LifeStyle:[]}
    ]
  }, [])
  const MatchedProfileOptions = useMemo(() => {
    return [
      // {BasicDetails:[]},
      // {ProfissionalDetails:[]},
      // {LocationDetails:[]}, 
      // {LifeStyle:[]}
      // Add as much as you wnat, it will dinamically render in view.
      { Personal: [] },
      { Education: [] },
      { Family: [] },
    ]
  }, [])

  const userDetails = [
    { id: 1, name: "Verified Profiles", count: "10", color: "#d89a5d", },
    { id: 2, name: "Upcoming Profiles", count: "30", color: "#d89a5d", },
    { id: 3, name: "Community Profiles", count: "20", color: "#d89a5d", },//data: selectedFilterOptions.CommunityProfiles,
    { id: 4, name: "Matched Profiles", count: "10", color: "#d89a5d", },//data: selectedFilterOptions.MatchedProfiles,
  ];

  const sendInterest = async (profileId) => {
    try {
      const response = await axios.post(
        matrimoneyEndPoints.SEND_INTEREST,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }
  const getAccept = async (profileId) => {

    try {
      const response = await axios.post(
        matrimoneyEndPoints.GET_ACCEPT,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };
  const getIGNORE = async (profileId) => {

    try {
      const response = await axios.post(
        matrimoneyEndPoints.GET_IGNORE,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };

  const [selectedIndexsearch, setSelectedIndexsearch] = useState(0);
  const [selectedLabel, setSelectedLabel] = useState("Quick Search");

  const filterInterestsAndProfileDatasearch = (index, label) => {
    setSelectedIndexsearch(index);
    setSelectedLabel(label);
  };
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const profilesearch = queryParams.get("profilesearch"); // will be "search-profiles"
  const [selectedCategory, setSelectedCategory] = useState("Advanced Search");
  const [clickedButton, setClickedButton] = useState(1);

  const [selectedOption, setSelectedOption] = useState({
    toheight: "",
    fromheight: "",
    toage: "",
    fromage: "",
    MaritalStatus: "",
    Country: "",
    State: "",
    city: "",
    Education: "",
    Profession: "",
    AnnualIncome: "",
    MotherTongue: "",
    Smoke: "",
    Drink: "",
    Complexion: "",
  });

  const [isOpen, setIsOpen] = useState({});

  const handleChangeAdvance = (e) => {
    const { name, value } = e.target;
    setSelectedOption((prev) => ({
      ...prev,
      [name]: value,
    }));
    setIsOpen((prev) => ({ ...prev, [name]: false }));
  };

  const handleFocus = (name) => {
    setIsOpen((prev) => ({ ...prev, [name]: true }));
  };


  const handleButtonClick = (value) => {
    setClickedButton(value);
  };

  // const getFilterOptionsByProfileId = (id) => {
  //   switch (id) {
  //     case 1:
  //       return verifiedProfileOptions;
  //     case 2:
  //       return upcomingFilterOptions;
  //     // case 3:
  //     //   return CommunityProfileOptions;
  //     // case 4:
  //     //   return MatchedProfileOptions;
  //     default:
  //       return [];
  //   }
  // };
  // Quick search api integretaion
  const fromAgeOptions = Array.from({ length: 83 }, (_, i) => i + 18); // [18, 19, ..., 100]

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [profiledataGet, setProfileDataGet] = useState(null);

  const [formValues, setFormValues] = useState({
    fromAge: "",
    toAge: "",
    fromHeight: "",
    toHeight: "",
    maritalStatus: "",
    country: null,
    state: null,
    city: null,
  });

  const getToAgeOptions = () => {
    const from = parseInt(formValues.fromAge);
    if (!from) return [];
    return Array.from({ length: 7 }, (_, i) => from + i).filter(age => age <= 100);
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setIsLoading(true);

        const countriesResponse = await getCountriesList();
        if (countriesResponse.status) {
          setCountries(countriesResponse.data);
        }

        const profileResponse = await getProfileDetails();
        if (profileResponse.status) {
          setProfileDataGet(profileResponse.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (profiledataGet) {
      const initialValues = {
        fromAge: profiledataGet.partnerDetails?.ageFrom || "",
        toAge: profiledataGet.partnerDetails?.ageTo || "",
        fromHeight: profiledataGet.partnerDetails?.heightFrom || "",
        toHeight: profiledataGet.partnerDetails?.heightTo || "",
        // maritalStatus: profiledataGet.customerPersonalDetails?.maritalStatus || "",
        // country: profiledataGet.customerContactDetails?.country || null,
        // state: profiledataGet.customerContactDetails?.state || null,
        // city: profiledataGet.customerContactDetails?.city || null,
      };

      setFormValues(initialValues);

      if (initialValues.country?.id) {
        fetchStatesListByCountry(initialValues.country.id).then(() => {
          if (initialValues.state?.id) {
            fetchCitiesListByState(initialValues.state.id);
          }
        });
      }
    }
  }, [profiledataGet]);

  const fetchStatesListByCountry = async (countryId) => {
    if (!countryId) return;
    try {
      const response = await getStatesListByCountry(countryId);
      if (response.status) {
        setStates(response.data);
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCitiesListByState = async (stateId) => {
    if (!stateId) return;
    try {
      const response = await getCitiessListByDistrict(stateId);
      if (response.status) {
        setCities(response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleFieldChange = (name, value) => {
    setFormValues(prev => ({ ...prev, [name]: value }));

    if (name === 'fromAge') {
      setFormValues(prev => ({ ...prev, toAge: "" }));
    }
  };

  const handleCountryChange = (event, value) => {
    setFormValues(prev => ({
      ...prev,
      country: value,
      state: null,
      city: null
    }));
    if (value?.id) {
      fetchStatesListByCountry(value.id);
    } else {
      setStates([]);
      setCities([]);
    }
  };

  const handleStateChange = (event, value) => {
    setFormValues(prev => ({
      ...prev,
      state: value,
      city: null
    }));
    if (value?.id) {
      fetchCitiesListByState(value.id);
    } else {
      setCities([]);
    }
  };

  const handleCityChange = (event, value) => {
    setFormValues(prev => ({ ...prev, city: value }));
  };

  const handleQuickSearch = async () => {
    try {
      setIsLoading(true);

      const payload = {
        fromAge: parseInt(formValues.fromAge) || 0,
        toAge: parseInt(formValues.toAge) || 0,
        fromHeight: parseInt(formValues.fromHeight) || 0,
        toHeight: parseInt(formValues.toHeight) || 0,
        maritalStatus: formValues.maritalStatus || "",
        country: formValues.country?.id || 0,
        state: formValues.state?.id || 0,
        city: formValues.city?.id || 0,
        skip: 0,
        limit: 10,
      };

      const response = await axios.post(
        matrimoneyEndPoints.GET_QUICK_SEARCH,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      );

      if (response.data && onSearchComplete) {
        onSearchComplete(response.data.data);
      }
    } catch (error) {
      console.error("Quick search failed:", error);
    } finally {
      setIsLoading(false);
    }
  };
  console.log("cities:", cities);
  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const fetchByIdSearch = async (profileCode) => {
    setIsLoading(true);
    setErrorMessage("");
    setSearchResult(null);
    try {
      const response = await axios.post(
        matrimoneyEndPoints.GET_IDSEARCH_LIST,
        { profileCode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      );

      if (response.data.status && response.data.data.length > 0) {
        setSearchResult(response.data.data);
      }
      else {
        setErrorMessage("No profile found with that ID.");
      }
    } catch (error) {
      console.error("Search failed:", error);
      setErrorMessage("An error occurred while searching.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    if (searchInput.trim()) {
      fetchByIdSearch(searchInput.trim());
    } else {
      setErrorMessage("Please enter a valid profile code.");
    }
  };

  return (
    <>
      <Box sx={{ padding: { xs: "10px", sm: "20px" } }}>
        {/* <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 2, sm: 4, md: 12, lg: 8 },
            backgroundColor: "#fdf1e0",
            padding: type != 'my-album' ? { xs: "10px", sm: "20px" } : "",
            marginLeft: { xs: "0", sm: selectedProfile ? "20%" : "0px" }
          }}
        >
          {type == "suggested-profiles" && userDetails.map((profile) => (
            <Box
              key={profile.id}
              onClick={() => {
                // if (profile.id === 3 || profile.id === 4) return;
                setSugestedProfileData(profile);
              }} sx={{
                cursor: "pointer",
                "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                position: "relative",
                textAlign: "center",
                padding: { xs: "30px 15px", sm: "50px 25px" },
                width: { xs: "140px", sm: "176px" },
                height: { xs: "140px", sm: "202.5px" },// sm: "182.5px"
                backgroundColor: selectedProfile?.id === profile.id ? "rgb(224, 141, 64)" : "white",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                clipPath: "polygon(0% 0%, 80% 0%, 100% 0%, 100% 75%, 50% 100%, 0% 75%, 0% 0%)",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: "-0px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                  height: "15px",
                  padding: "10px",
                  backgroundColor: "rgba(245,206,165,255)",
                  borderRadius: "20px",
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                  height: "20px",
                  backgroundColor: "#fdf1e0",
                  clipPath: "polygon(20% 20%, 50% 100%, 100% 20%)",
                },
              }}
            >
              <Typography sx={{
                fontFamily: '"Inter var"',
                fontWeight: 400,
                fontSize: { xs: "20px", sm: "30px" },
                lineHeight: "100%",
                letterSpacing: "0",
                textAlign: "center",
                color: selectedProfile?.id === profile.id ? "#fff" : "rgb(224, 141, 64)",
                "&:hover": { color: "#fff" },
              }}>
                {profile.name}
              </Typography>

              <Button sx={{
                borderRadius: "100%",
                backgroundColor: selectedProfile?.id === profile.id ? "white" : "rgba(245,206,165,255)",
                //  backgroundColor: "rgba(245,206,165,255)", 
                // color: "rgb(224, 141, 64)", 
                color: selectedProfile?.id === profile.id ? "rgb(224, 141, 64)" : "rgb(224, 141, 64)",
                "&:hover": { color: "#fff" },
                width: "40px", height: "50px", marginTop: "10px",
              }}>
                {profile.count}
              </Button>
            </Box>
          ))}
        </Box> */}

        <Box sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 5 },
          // alignItems: "center"
        }}>
          {(selectedProfile && (type == "suggested-profiles" || type == "verified-profiles")) && (
            <Box sx={{
              width: { xs: "100%", sm: "400px" },
              padding: { xs: "15px", sm: "10px" },
              marginTop: { xs: "0", sm: selectedProfile ? "0px" : "0px" },
              backgroundColor: "white",
              height: "auto",
              border: "2px solid rgb(224, 141, 64)",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "8px",
            }}>
              {/* <IconButton onClick={handleOnclick}>
                <ArrowBackIcon sx={{ color: "black", marginBottom: "10px" }} />
              </IconButton>
              <Typography 
            sx={{
                fontWeight: "bold",
                fontSize:"16px",
                marginBottom: 2,
                        fontFamily: '"Inter var"',
                textAlign: { xs: "center", sm: "left" }
              }}>
                {selectedProfile.name} Details
              </Typography> */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton onClick={handleOnclick}>
                  <ArrowBackIcon sx={{ color: "black", }} />
                </IconButton>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    fontFamily: '"Inter var"',
                    textAlign: { xs: "center", sm: "left" }
                  }}
                >
                  {selectedProfile.name} Details
                </Typography>
              </Box>

              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px", marginTop: "20px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ ...FontStyles.vrefiedSerach }}
                  onClick={() => handleSearcch(filterOptions)}
                >
                  Search
                </Button>
              </div>
              <Box
              >
                <Accordion >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ...FontStyles.verfiedPersaonal }}>Personal</Typography>
                  </AccordionSummary>

                  <AccordionDetails style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                    <>
                      {(selectedProfile.id === 1 || selectedProfile.id === 2) && (
                        <>
                          {/* Age Filter */}

                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={ageOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.fromAge}
                                onChange={(event, newValue) => handleSelectChange("fromAge", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="From Age"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                              <Autocomplete
                                options={ageOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.toAge}
                                onChange={(event, newValue) => handleSelectChange("toAge", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="To Age"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                            </Box>
                          </StyledFormControl>

                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={heightOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.fromHeight}
                                onChange={(event, newValue) => handleSelectChange("fromHeight", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="From Height"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                              <Autocomplete
                                options={heightOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.toHeight}
                                onChange={(event, newValue) => handleSelectChange("toHeight", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="To Height"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={padams}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.padam}
                                onChange={(event, newValue) => handleSelectChange("padam", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Padam"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                              <StyledTextField
                                label="Birth Place"
                                variant="outlined"
                                size="small"
                                fullWidth
                                name="birthPlace"
                                value={filterOptions.birthPlace}
                                onChange={handleInputChange}
                              />
                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={stars}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.star}
                                onChange={(event, newValue) => handleSelectChange("star", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Star"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                              <Autocomplete
                                options={moonsigns}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.moonsign}
                                onChange={(event, newValue) => handleSelectChange("moonsign", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Moonsign"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <StyledTextField
                                label="Gothram"
                                variant="outlined"
                                size="small"
                                fullWidth
                                name="Gothram"
                                value={filterOptions.gothram}
                                onChange={handleInputChange}
                              />
                              <Autocomplete
                                options={khujaDhoshamOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.khujaDhosham}
                                onChange={(event, newValue) => handleSelectChange("khujaDhosham", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Khuja Dhosham"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={bloodGroups}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.bloodGroup}
                                onChange={(event, newValue) => handleSelectChange("bloodGroup", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Blood Group"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                              <Autocomplete
                                options={motherTongue}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.motherTongue}
                                onChange={(event, newValue) => handleSelectChange("motherTongue", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Mother Tongue"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={helthCondition}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.helthCondition}
                                onChange={(event, newValue) => handleSelectChange("helthCondition", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Helth Condition"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                              <Autocomplete
                                options={complexions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.complexion}
                                onChange={(event, newValue) => handleSelectChange("complexion", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Complexion"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={maritalStatuses}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.maritalStatus}
                                onChange={(event, newValue) => handleSelectChange("maritalStatus", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Marital Status"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                              <Autocomplete
                                options={smokeOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.smoke}
                                onChange={(event, newValue) => handleSelectChange("smoke", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Smoke"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>
                          <StyledFormControl fullWidth size="small">
                            <Box display="flex" gap={2}>
                              <Autocomplete
                                options={drinkOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.drink}
                                onChange={(event, newValue) => handleSelectChange("drink", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Drink"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />
                              <Autocomplete
                                options={foodPreferences}
                                getOptionLabel={(option) => option?.name || ""}
                                value={filterOptions.food}
                                onChange={(event, newValue) => handleSelectChange("food", newValue)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    label="Food"
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                                fullWidth
                              />

                            </Box>
                          </StyledFormControl>

                          <StyledFormControl fullWidth size="small">
                            <Autocomplete
                              options={[{ id: "yes", name: "Yes" }, { id: "no", name: "No" }]}
                              getOptionLabel={(option) => option?.name || ""}
                              value={filterOptions.passport}
                              onChange={(event, newValue) => handleSelectChange("passport", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Passport"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />
                            <Autocomplete
                              options={countryOptions}
                              getOptionLabel={(option) => option?.countryName || ""}
                              value={filterOptions.country}
                              onChange={(event, newValue) => handleSelectChange("country", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Country"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />
                            <Autocomplete
                              options={stateOptions}
                              getOptionLabel={(option) => option?.stateName || ""}
                              value={filterOptions.state}
                              onChange={(event, newValue) => handleSelectChange("state", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="State"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />

                            <Autocomplete
                              options={districtOptions}
                              getOptionLabel={(option) => option?.districtName || ""}
                              value={filterOptions.district}
                              onChange={(event, newValue) => handleSelectChange("district", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="District"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />
                            <Autocomplete
                              options={cityOptions}
                              getOptionLabel={(option) => option?.cityName || ""}
                              value={filterOptions.city}
                              onChange={(event, newValue) => handleSelectChange("city", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="City"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />
                          </StyledFormControl>

                        </>
                      )}


                    </>

                  </AccordionDetails>
                </Accordion>
                <Accordion >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ...FontStyles.verfiedPersaonal }}>Education</Typography>
                  </AccordionSummary>

                  <AccordionDetails style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                    <>
                      {(selectedProfile.id === 1 || selectedProfile.id === 2) && (
                        <>
                          {/* Age Filter */}

                          <StyledFormControl fullWidth size="small">

                            <Autocomplete
                              options={employedInOptions}
                              getOptionLabel={(option) => option?.name || ""}
                              value={filterOptions.employedIn}
                              onChange={(event, newValue) => handleSelectChange("employedIn", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Employed In"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />

                            <Autocomplete
                              options={professionOptions}
                              getOptionLabel={(option) => option?.professionName || ""}
                              value={filterOptions.profession}
                              onChange={(event, newValue) => handleSelectChange("profession", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Profession"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />



                            <Autocomplete
                              options={designationOptions}
                              getOptionLabel={(option) => option?.designationName || ""}
                              value={filterOptions.designation}
                              onChange={(event, newValue) => handleSelectChange("designation", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Designation"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />

                            <Autocomplete
                              options={[{ id: "india", name: "India" }, { id: "abroad", name: "Abroad" }]}
                              getOptionLabel={(option) => option?.name || ""}
                              value={filterOptions.workLocation}
                              onChange={(event, newValue) => handleSelectChange("workLocation", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Work Location"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />


                            {filterOptions?.workLocation != "" && filterOptions?.workLocation?.id != "india" && <Autocomplete
                              options={countryOptions}
                              getOptionLabel={(option) => option?.countryName || ""}
                              value={filterOptions.workingCountry}
                              onChange={(event, newValue) => handleSelectChange("workingCountry", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Working Country"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />}
                            <Autocomplete
                              options={workingStateOptions}
                              getOptionLabel={(option) => option?.stateName || ""}
                              value={filterOptions.workingState}
                              onChange={(event, newValue) => handleSelectChange("workingState", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Working State"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />
                            {/* <Autocomplete
                                        options={districtOptions}
                                        getOptionLabel={(option) => option?.districtName || ""}
                                        value={filterOptions.district}
                                        onChange={(event, newValue) => handleSelectChange("district", newValue)}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => (
                                          <StyledTextField
                                            {...params}
                                            label="District"
                                            variant="outlined"
                                            size="small"
                                          />
                                        )}
                                        fullWidth
                                      /> */}
                            {/* <Autocomplete
                                        options={cityOptions}
                                        getOptionLabel={(option) => option?.cityName || ""}
                                        value={filterOptions.city}
                                        onChange={(event, newValue) => handleSelectChange("city", newValue)}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => (
                                          <StyledTextField
                                            {...params}
                                            label="City"
                                            variant="outlined"
                                            size="small"
                                          />
                                        )}
                                        fullWidth
                                      /> */}
                            <StyledTextField
                              label="Total Experience"
                              variant="outlined"
                              size="small"
                              type="number"
                              fullWidth
                              name="totalExperience"
                              value={filterOptions.totalExperience}
                              onChange={handleInputChange}
                            />

                            <StyledTextField
                              label="Annual Income in Lakhs"
                              variant="outlined"
                              size="small"
                              type="number"
                              fullWidth
                              name="annalIncome"
                              value={filterOptions.annualIncome}
                              onChange={handleInputChange}
                            />

                          </StyledFormControl>

                        </>
                      )}


                    </>

                  </AccordionDetails>
                </Accordion>
                <Accordion >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ ...FontStyles.verfiedPersaonal }}>Family</Typography>
                  </AccordionSummary>

                  <AccordionDetails style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                    <>
                      {(selectedProfile.id === 1 || selectedProfile.id === 2) && (
                        <>
                          {/* Age Filter */}

                          <StyledFormControl fullWidth size="small">

                            <Autocomplete
                              options={familyStatusOptions}
                              getOptionLabel={(option) => option?.name || ""}
                              value={filterOptions.familyStatus}
                              onChange={(event, newValue) => handleSelectChange("familyStatus", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Family Status"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />

                            <Autocomplete
                              options={familyTypeOptions}
                              getOptionLabel={(option) => option?.name || ""}
                              value={filterOptions.familyType}
                              onChange={(event, newValue) => handleSelectChange("familyType", newValue)}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              renderInput={(params) => (
                                <StyledTextField
                                  {...params}
                                  label="Family Type"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                              fullWidth
                            />

                          </StyledFormControl>

                        </>
                      )}


                    </>

                  </AccordionDetails>
                </Accordion>
              </Box>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px", marginTop: "20px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ ...FontStyles.vrefiedSerach }}
                  onClick={() => handleSearcch(filterOptions)}
                >
                  Search
                </Button>
              </div>
              {/* age */}
              <Modal open={popup} onClose={() => setPopup(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {/* {'age'} */}
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopup(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Age Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "50%" }}>
                      <Select value={fromAge} onChange={handleFromAgeChange} displayEmpty>
                        {[...Array(83)].map((_, i) => (
                          <MenuItem key={i + 18} value={i + 18}>
                            {i + 18} Years
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ width: "50%" }}>
                      <Select value={toAge} onChange={handleToAgeChange} displayEmpty>
                        {[...Array(83)].map((_, i) => (
                          <MenuItem key={i + 18} value={i + 18}>
                            {i + 18} Years
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => {
                        setFromAge(18);
                        setToAge(24);
                        setSelectedAge("18 yrs - 24 yrs");
                      }}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopup(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
              {/* height popup */}
              <Modal open={popupHeight} onClose={() => setPopupHeight(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopupHeight(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Height Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "50%" }}>
                      <Select value={fromHeight} onChange={handleFromHeightChange} displayEmpty>
                        <MenuItem value="4’6”">4’6”</MenuItem>
                        <MenuItem value="5’0”">5’0”</MenuItem>
                        <MenuItem value="5’6”">5’6”</MenuItem>
                        <MenuItem value="6’0”">6’0”</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl sx={{ width: "50%" }}>
                      <Select value={toHeight} onChange={handleToHeightChange} displayEmpty>
                        <MenuItem value="5’0”">5’0”</MenuItem>
                        <MenuItem value="5’6”">5’6”</MenuItem>
                        <MenuItem value="6’0”">6’0”</MenuItem>
                        <MenuItem value="6’6”">6’6”</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => {
                        setFromHeight("4’6”");
                        setToHeight("5’6”");
                        setSelectedHeight("4’6” - 5’6”");
                      }}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopupHeight(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
              {/* Profile created by */}
              <Modal open={popupProfile} onclose={() => setPopupProfile(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopupProfile(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Height Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <Select value={Profile} onChange={handlechangeProfile} displayEmpty>
                        <MenuItem value="Brother”">Brother</MenuItem>
                        <MenuItem value="Sister”">Sister </MenuItem>
                        <MenuItem value="Father”">Father</MenuItem>
                        <MenuItem value="Mother”">Mother</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => setProfile(false)}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopupProfile(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
              <Modal open={popupMarital} onclose={() => setPopupMarital(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopupMarital(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Height Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <Select value={marital} onChange={onChangeMarital} displayEmpty>
                        <MenuItem value="Single">Single</MenuItem>
                        <MenuItem value="Divorced">Divorced</MenuItem>
                        <MenuItem value="Not Married">Not Married</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => setMarital(false)}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopupMarital(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
              <Modal open={popupLanguage} onclose={() => setPopupLanguage(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopupLanguage(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Height Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <Select value={language} onChange={onchangeLanguage} displayEmpty>
                        <MenuItem value="Telugu">Telugu</MenuItem>
                        <MenuItem value="Hindi">Hindi</MenuItem>
                        <MenuItem value="Tamil">Tamil</MenuItem>
                        <MenuItem value="Kannada">Kannada</MenuItem>

                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => setLanguage(false)}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopupLanguage(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
              <Modal open={popupPhysical} onclose={() => setPopupPhysical(false)}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%" },
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Button onClick={() => setPopupPhysical(false)} sx={{ minWidth: "auto", padding: 0 }}>
                      <ArrowBackIcon sx={{ color: "black" }} />
                    </Button>
                    <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                      Select Your Height Range
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <Select value={physical} onChange={onChange} displayEmpty>
                        <MenuItem value="Normal">Normal</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <Button
                      onClick={() => setPhysical(false)}
                      sx={{
                        backgroundColor: "white",
                        color: "#B56E2C",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                        borderRadius: "20px",
                        border: "2px solid #B56E2C",
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#B56E2C",
                        color: "white",
                        padding: "10px",
                        width: "111px",
                        "&:hover": { backgroundColor: "#8E5723" },
                        borderRadius: "20px",
                      }}
                      onClick={() => setPopupPhysical(false)}
                    >
                      Edit Now
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </Box>
          )}
          {type != "my-album" && <Grid container xs={12} spacing={2}>
            {(type == "suggested-profiles" && !selectedProfile) && <Grid item md={2} xs={12} style={{ marginTop: '20px' }}></Grid>}
            {type == "interests" ?
              <Grid item md={3} xs={12} style={{ marginTop: '10px', }}>
                <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    marginLeft: { xs: "0px", sm: "20px" },

                    width: { xs: "100%", sm: "257px" },
                  }}
                >
                  {[
                    'Interest Sent',
                    'Interest Viewed',
                    'Interest Accepted',
                    'Interest Pending',
                    'Interest Received',
                    'Interest Ignored',
                  ].map((label, index) => {
                    let count = ""
                    if (label === 'Interest Sent') {
                      count = interestsCount?.totalSendInterestCount;
                    } else if (label === 'Interest Viewed') {
                      count = interestsCount?.interestViewedCount;
                    } else if (label === 'Interest Accepted') {
                      count = interestsCount?.acceptedCount;
                    } else if (label === 'Interest Pending') {
                      count = interestsCount?.pendingCount;
                    } else if (label === 'Interest Received') {
                      count = interestsCount?.totalReceivedInterestCount;
                    } else if (label === 'Interest Ignored') {
                      count = interestsCount?.rejectedCount;
                    }
                    return (
                      <Box
                        key={index}
                        onClick={() => filterInterestsAndProfileData(index, label)}
                        sx={{
                          ...FontStyles.filtertext,
                          backgroundColor: selectedIndex === index ? "#C1721F" : 'transparent',
                          color: selectedIndex === index ? 'white' : 'black',

                        }}
                      >
                        <span>{label}</span>

                        <Box
                          sx={{
                            fontFamily: '"Inter var"',
                            fontWeight: 700,
                            fontSize: '15px',
                            backgroundColor: selectedIndex === index ? "#fff" : '#C1721F',
                            color: selectedIndex === index ? '#C1721F' : 'white',
                            borderRadius: '50px',
                            padding: '5px',
                            minWidth: '32px',
                            textAlign: 'center'
                          }}
                        >
                          {count !== undefined && count !== null ? count : ''}
                        </Box>
                      </Box>
                    )
                  })}

                </Box>
              </Grid>
              : type == "profiles" ? <Grid item md={3} xs={12} style={{ marginTop: '10px' }}>
                <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    marginLeft: { xs: "0px", sm: "20px" },
                    width: { xs: "100%", sm: "257px" },
                  }}
                >
                  {[
                    'Shortlisted Profiles',
                    'Blocklisted Profiles',
                    'Profiles I Viewed',
                    'Viewed My Profile',
                  ].map((label, index) => {
                    let count = ""
                    if (label == "Shortlisted Profiles") {
                      count = profilesCount.totalShortListedCount
                    } else if (label == "Blocklisted Profiles") {
                      count = profilesCount.totalBlockedCount
                    } else if (label == "Profiles I Viewed") {
                      count = profilesCount.totalIViewedCount
                    } else if (label == "Viewed My Profile") {
                      count = profilesCount.totalViewedCount
                    }
                    return (<Box
                      key={index}
                      onClick={() => filterInterestsAndProfileData(index, label)}
                      sx={{

                        backgroundColor: selectedIndex === index ? "#C1721F" : 'transparent',
                        color: selectedIndex === index ? 'white' : 'black',
                        ...FontStyles.filtertext,
                      }}
                    >
                      <span>{label}</span>
                      <Box
                        sx={{
                          fontFamily: '"Inter var"',
                          fontWeight: 700,
                          fontSize: '15px',
                          backgroundColor: selectedIndex === index ? "#fff" : '#C1721F',
                          color: selectedIndex === index ? '#C1721F' : 'white',
                          borderRadius: '50px',
                          padding: '5px',
                          minWidth: '32px',
                          textAlign: 'center'
                        }}
                      >
                        {count !== undefined && count !== null ? count : ''}
                      </Box>
                    </Box>)

                  })}
                </Box>
              </Grid> : null
            }
            {profilesearch !== "search-profiles" && (
              //   <Grid item
              //   xs={12}
              //   sm={type === "profiles" ? 8 :type == "interests" ?8: selectedProfile ? 12 : 12}
              //   md={type === "profiles" ? 8 :type == "interests" ?8: selectedProfile ? 12 : 12}
              //   lg={type === "profiles" ? 8 :type == "interests" ?8: selectedProfile ? 12 : 12}
              //   xl={type === "profiles" ? 8 :type == "interests" ?8: selectedProfile ? 12 : 12}
              // >
              <Grid item
                xs={12}
                sm={type === "profiles" ? 9 : type == "interests" ? 9 : selectedProfile ? 12 : 12}
                md={type === "profiles" ? 9 : type == "interests" ? 9 : selectedProfile ? 12 : 12}
                lg={type === "profiles" ? 9 : type == "interests" ? 9 : selectedProfile ? 12 : 12}
                xl={type === "profiles" ? 9 : type == "interests" ? 9 : selectedProfile ? 12 : 12}
                sx={{
                  marginLeft:
                    type === "profiles"
                      ? "-5%"
                      : type === "interests"
                        ? "-5%"
                        : 0,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 2, sm: 3 },
                    padding: { xs: "10px", sm: "20px" },
                    justifyContent: "center",
                  }}
                >
                  <Box

                  >
                    {label === "ID Search" && (
                      <Card
                        sx={{
                          ...styles.cardsuggetion,
                          height: "100%",
                          padding: { xs: "10%", sm: "40px" },
                        }}
                      >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Box
                          sx={{
                            width: "100%",
                            padding: { xs: "15px", sm: "30px" },
                            backgroundColor: "white",
                            height: "auto",
                            border: "2px solid rgb(224, 141, 64)",
                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                            borderRadius: "8px",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item xs={12} sm={12}
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: { xs: "center", sm: "flex-start" },
                              }}
                            >
                              <TextField fullWidth />
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#C1721F",
                                  color: "white",
                                  borderRadius: "4px",
                                  width: "150px",
                                  height: "52px",
                                  fontFamily: "Roboto",
                                  padding: { xs: "8px 12px", sm: "10px 4px" },
                                  fontSize: { xs: "12px", sm: "18px" },
                                }}
                                startIcon={<SearchIcon sx={{ color: "white" }} />}
                              >
                                Search
                              </Button>
                            </Grid>
                          </Grid>
                        </Box>
                      </Card>
                    )}
                    {profilesearch !== "search-profiles" && (
                      <Grid container spacing={1}>

                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            mb: 2,
                            marginTop: { xs: "auto", md: "-5%" }
                          }}
                        >
                          <Box display="inline-flex">
                            <CustomPagination
                              totalItems={totalCount}
                              itemsPerPage={itemsPerPage}
                              currentPage={currentPage}
                              onPageChange={handlePageChange}
                            />
                          </Box>
                        </Grid>

                        {spinner ? (
                          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                            <CircularProgress color="primary" size={60} />
                          </Grid>
                        ) : profileData.length > 0 ? (
                          profileData.map((profile) => (
                            <Grid item xs={12} key={profile.id}
                              sx={{
                                ...styles.sug,
                                marginLeft: { xs: "20px", sm: "auto", md: "30px" },
                                padding: { xs: "10%", sm: "20px" },
                                mb: "30px"
                              }}>
                              <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                              <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                              <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                              <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                              <Card
                                sx={{
                                  width: { xs: "100%", md: "95%" },
                                  padding: { xs: "15px", sm: "10px" },
                                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                  border: "2px solid rgb(224, 141, 64)",
                                  marginY: { xs: "20px", sm: "30px" },
                                  height: "auto",
                                  marginLeft: { xs: "10px" }
                                }}
                              >
                                <Grid container spacing={2} alignItems="center">
                                  <Grid item xs={12} md={2} xxl={2}>
                                    <img
                                      src={
                                        profile.profilePicture
                                          ? profile.profilePicture
                                          : "https://via.placeholder.com/168?text=No+Image"
                                      }
                                      alt={profile.name}
                                      style={{
                                        width: '100%',
                                        height: '168px',
                                        borderRadius: "20px",
                                        objectFit: 'contain', // show full image without cropping
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={9}>
                                    <Typography
                                      sx={{ ...FontStyles.profilenameforcard }}
                                    >
                                      {profile.name}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        ...FontStyles.displayText

                                      }}
                                    >
                                      {profile.displayText}
                                    </Typography>

                                    <Stack direction="row" flexWrap="wrap" gap={1} mb={1} >
                                      <Button

                                        sx={{
                                          ...FontStyles.profileId
                                        }}
                                        onClick={() =>
                                          navigate(`/profile/ProfileView`, {
                                            state: { profileId: profile.id },
                                          })
                                        }
                                      >
                                        AM101302
                                      </Button>

                                      {/* <Button
                                            startIcon={<AccountCircleIcon
                                              sx={{ width: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" }, height: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" } }}
                                            />}
                                            sx={{
                                              ...styles.interstbuttonview,
                                            }}
                                            onClick={() =>
                                              navigate(`/profile/ProfileView`, {
                                                state: { profileId: profile.id },
                                              })
                                            }
                                          >
                                            View Profile
                                          </Button> */}

                                      {label !== "Blocklisted Profiles" && (
                                        <Button
                                          startIcon={
                                            <AccountCircleIcon
                                              sx={{
                                                width: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" },
                                                height: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" },
                                              }}
                                            />
                                          }
                                          sx={{
                                            ...styles.interstbuttonview,
                                          }}
                                          onClick={() =>
                                            navigate(`/profile/ProfileView`, {
                                              state: { profileId: profile.id },
                                            })
                                          }
                                        >
                                          View Profile
                                        </Button>
                                      )}


                                      {label !== "Blocklisted Profiles" &&
                                        label !== "Interest Sent" &&
                                        label !== "Interest Viewed" &&
                                        label !== "Interest Received" && label !== "Interest Accepted" && label !== "Interest Pending" &&
                                        label !== "Interest Ignored" && (
                                          <Button startIcon={<SendIcon sx={{ width: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" }, height: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" } }} />}
                                            sx={{
                                              ...styles.interstbutton
                                            }}
                                            onClick={() => sendInterest(profile.id)}
                                          >
                                            Send Interest
                                          </Button>
                                        )}

                                      {(label === "Interest Received") && (
                                        <>
                                          <Button
                                            variant="contained"
                                            sx={{
                                              ...FontStyles.accept
                                            }}
                                            onClick={() => getAccept(profile.id)}                                          >
                                            Accept
                                          </Button>
                                          <Button
                                            variant="contained"
                                            sx={{
                                              ...FontStyles.ignore
                                            }}
                                            onClick={() => getIGNORE(profile.id)}
                                          >
                                            Ignore
                                          </Button>
                                        </>
                                      )}
                                      {
                                        type !== "suggested-profiles" && (
                                          <Button
                                            sx={{
                                              ...styles.chip
                                            }}
                                          >
                                            {label === "Interest Sent" ? "Sent On : " : label === "Blocklisted Profiles" ? "Blocked On : " : label === "Interest Viewed" ? "Viewed On : " :
                                              label == "Interest Received" ? "Received On : " : label == "Interest Accepted" ? "Accepted On : " : label == "Interest Pending" ? "Pending On : " : label == "Shortlisted Profiles" ? "Shortlisted On : " : label == "Blocklisted Profiles" ? "Blocklisted On : " :
                                                label == 'Profiles I Viewed' ? "I Viewed On : " : label == 'Profiles I Viewed' ? "Viewed On" : label == 'Viewed My Profile' ? "Viewed On : " : "Ignored On : "}
                                            {profile?.dateTimeRead}
                                          </Button>
                                        )
                                      }

                                    </Stack>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          ))

                        ) : (
                          <Grid item xs={12} sx={{ textAlign: 'center', mt: 4 }}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                              alt="No Data Found"
                              style={{ marginBottom: 16, maxWidth: '100px', opacity: 0.6 }}
                            />
                            <Typography variant="h6" color="text.secondary">
                              No Profiles Found
                            </Typography>
                          </Grid>
                        )}

                      </Grid>
                    )}
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>}
        </Box>
        {type == "my-album" && <>
          <Grid>
            <div style={{ textAlign: 'end' }}>
              <Button sx={{ ...FontStyles.addphotoTEXt }} onClick={handleOpen}>
                + Add Photo
              </Button>
            </div>
            {profileImages.length > 0 && (
              <Box sx={{
                backgroundColor: "white",
                padding: { xs: "15px", sm: "20px" },
                borderRadius: "8px",
                width: "100%"
              }}>
                {/* <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '10px',
                    marginTop: '20px'
                  }}
                > */}
                <Box
                  sx={{
                    display: 'grid',
                    gap: 2,
                    marginTop: '20px',
                    gridTemplateColumns: {
                      xs: '1fr',
                      sm: 'repeat(2, 1fr)',
                      md: 'repeat(3, 1fr)',
                      lg: 'repeat(4, 1fr)',
                    }
                  }}
                >
                  {profileImages.map((each, index) => (
                    <img
                      key={index}
                      src={each.imageUrl}
                      alt={`Profile ${index}`}
                      style={{
                        width: '100%',
                        height: '290px',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        backgroundColor: '#f0f0f0'
                      }}
                    />

                  ))}
                </Box>
              </Box>
            )}

            <Modal open={open} onClose={handleClose}>
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 460,
                  bgcolor: 'background.paper',
                  borderRadius: 3,
                  boxShadow: 24,
                  p: 4,
                }}
              >
                {uploadImagesMsg?.status && (
                  <Box mt={2} p={2} textAlign="center" borderRadius={2} bgcolor={uploadImagesMsg?.isSuccess ? "#e8f5e9" : "red"}>
                    <Typography color="green" fontWeight={600}>
                      {uploadImagesMsg?.message}
                    </Typography>
                  </Box>
                )}
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6" fontWeight={600}>
                    Add Photo to Album
                  </Typography>
                  <IconButton onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Upload Box */}
                <Box
                  component="label"
                  htmlFor="file-upload"
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                    <InsertPhotoIcon sx={{ fontSize: 150, color: '#C1721F' }} />
                  </Box>
                  <input
                    id="file-upload"
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    multiple
                    hidden
                    onChange={handleFileChange}
                  />
                </Box>

                {/* Selected Files */}
                {files.length > 0 && (
                  <Box mt={2}>
                    <Typography fontWeight={500} fontSize="14px" mb={1}>
                      Selected Files:
                    </Typography>
                    <Box
                      sx={{
                        maxHeight: 100,
                        overflowY: 'auto',
                        border: '1px solid #eee',
                        borderRadius: 1,
                        p: 1,
                        fontSize: '13px',
                        bgcolor: '#fafafa'
                      }}
                    >
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {files.map((file, index) => (
                          <li key={index}>{file.name}</li>
                        ))}
                      </ul>
                    </Box>
                  </Box>
                )}

                {/* Actions */}
                <Stack direction="row" justifyContent="flex-end" gap={1} mt={4}>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button
                    variant="contained"
                    onClick={handleUpload}
                    disabled={files.length === 0}
                    sx={{
                      backgroundColor: '#C1721F',
                      color: 'white',
                      '&:hover': { backgroundColor: '#a65e1a' }
                    }}
                  >
                    Upload ({files.length}/5)
                  </Button>
                </Stack>
              </Box>
            </Modal>
          </Grid>
        </>}
        <>
          {profilesearch === "search-profiles" && (
            <Grid container spacing={2}>
              <Grid item md={3} xs={12} style={{ marginTop: '10px' }}>
                <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    marginLeft: { xs: "0px", sm: "20px" },
                    width: { xs: "100%", sm: "257px" },
                  }}
                >
                  {['Quick Search', 'Advanced Search', 'ID Search'].map((label, index) => (
                    <Box
                      key={index}
                      onClick={() => filterInterestsAndProfileDatasearch(index, label)}
                      sx={{
                        backgroundColor: selectedIndexsearch === index ? "#C1721F" : 'transparent',
                        color: selectedIndexsearch === index ? 'white' : 'black',
                        ...FontStyles.filtertext,

                      }}
                    >
                      <span>{label}</span>
                    </Box>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={9}>
                {selectedLabel === "Quick Search" && (
                  <Card
                    sx={{
                      ...styles.cardsuggetion,
                      height: "100%",
                      padding: { xs: "10%", sm: "40px" },
                    }}
                  >
                    <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                    <Box
                      sx={{
                        width: "100%",
                        padding: { xs: "15px", sm: "30px" },
                        backgroundColor: "white",
                        height: "auto",
                        border: "2px solid #C1721F",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                        borderRadius: "8px",
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <StyledTextField
                            select
                            label="From Age"
                            name="fromAge"
                            size="small"
                            value={formValues.fromAge}
                            onChange={(e) => handleFieldChange('fromAge', e.target.value)}
                            fullWidth
                            SelectProps={{ native: true }}
                            disabled={isLoading}
                          >
                            <option value=""></option>
                            {fromAgeOptions.map((age) => (
                              <option key={age} value={age}>
                                {age}
                              </option>
                            ))}
                          </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <StyledTextField
                            select
                            label="To Age"
                            size="small"
                            name="toAge"
                            value={formValues.toAge}
                            onChange={(e) => handleFieldChange('toAge', e.target.value)}
                            fullWidth
                            SelectProps={{ native: true }}
                            disabled={!formValues.fromAge || isLoading}
                          >
                            <option value=""></option>
                            {getToAgeOptions().map((age) => (
                              <option key={age} value={age}>
                                {age}
                              </option>
                            ))}
                          </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <StyledTextField
                            type="number"
                            label="From Height (cm)"
                            name="fromHeight"
                            value={formValues.fromHeight}
                            onChange={(e) => handleFieldChange('fromHeight', e.target.value)}
                            fullWidth
                            size="small"
                            disabled={isLoading}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <StyledTextField
                            type="number"
                            label="To Height (cm)"
                            name="toHeight"
                            value={formValues.toHeight}
                            onChange={(e) => handleFieldChange('toHeight', e.target.value)}
                            fullWidth
                            size="small"
                            disabled={isLoading}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          
                          <Autocomplete
                            options={maritalStatusOptions}
                            getOptionLabel={(option) => option.label}
                            onChange={(e, value) => handleFieldChange('maritalStatus', value?.value || "")}
                            value={
                              maritalStatusOptions.find(
                                (option) => option.value === formValues.maritalStatus
                              ) || null
                            }
                            renderInput={(params) => (
                              <StyledTextField {...params} label="Marital Status" fullWidth size="small"/>
                            )}
                            disabled={isLoading}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={countries}
                            getOptionLabel={(option) => option.countryName || ""}
                            onChange={handleCountryChange}
                            value={formValues.country}
                            renderInput={(params) => (
                              <StyledTextField {...params} label="Country" fullWidth size="small"/>
                            )}
                            disabled={isLoading || countries.length === 0}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={states}
                            getOptionLabel={(option) => option.stateName || ""}
                            onChange={handleStateChange}
                            value={formValues.state}
                            renderInput={(params) => (
                              <StyledTextField {...params} label="State" fullWidth size="small"/>
                            )}
                            disabled={isLoading || !formValues.country || states.length === 0}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={cities}
                            getOptionLabel={(option) => option.cityName || ""}
                            onChange={handleCityChange}
                            value={formValues.city}
                            renderInput={(params) => (
                              <StyledTextField {...params} label="City" fullWidth size="small"/>
                            )}
                            disabled={isLoading || !formValues.state || cities.length === 0}
                          />
                        </Grid>
                      </Grid>
                      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", gap: "20px", marginTop: "20px" }}>
                        <Button
                          variant="contained"
                          sx={{
                            ...styles.searchcancel
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{ ...styles.search }}
                          onClick={handleQuickSearch}
                          disabled={isLoading}
                        >
                          {isLoading ? 'Searching...' : 'Search'}
                        </Button>

                      </Box>
                    </Box>
                  </Card>
                )}
                {selectedLabel === "Advanced Search" && (
                  <Card
                    sx={{
                      ...styles.cardsuggetion,
                      height: "100%",
                      padding: { xs: "10%", sm: "30px" },
                    }}
                  >
                    <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                    <Box
                      sx={{
                        width: "100%",
                        padding: { xs: "15px", sm: "30px" },
                        backgroundColor: "white",
                        height: "auto",
                        border: "2px solid #C1721F",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                        borderRadius: "8px",
                      }}
                    >
                      <Advance />
                    </Box>
                  </Card>
                )}
                {selectedLabel === "ID Search" && (
                  <Box>
                    <Card
                      sx={{
                        ...styles.cardsuggetion,
                        height: "100%",
                        padding: { xs: "10%", sm: "40px" },
                        marginBottom: "20px",
                      }}
                    >
                      <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                      <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                      <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                      <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

                      <Box
                        sx={{
                          width: "100%",
                          padding: { xs: "15px", sm: "30px" },
                          backgroundColor: "white",
                          height: "auto",
                          border: "2px solid #C1721F",
                          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                          borderRadius: "8px",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: { xs: "center", sm: "flex-start" },
                          }}>
                            <StyledTextField
                              fullWidth
                              placeholder="Enter Profile Code (e.g. ANPM12456)"
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                            />
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#C1721F",
                                color: "white",
                                borderRadius: "4px",
                                width: "150px",
                                marginTop: { xs: "auto", md: "-2%" },
                                height: "52px",
                                fontFamily: "Roboto",
                                fontSize: { xs: "12px", sm: "18px" },
                              }}
                              startIcon={<SearchIcon sx={{ color: "white" }} />}
                              onClick={handleSearch}
                            >
                              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Search"}
                            </Button>
                          </Grid>
                          {errorMessage && (
                            <Grid item xs={12}>
                              <Typography color="error">{errorMessage}</Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    </Card>

                    {Array.isArray(searchResult) && searchResult.length > 0 && searchResult.map((profile) => (
                      <Card
                        key={profile.id}
                        sx={{
                          ...styles.cardsuggetion,
                          padding: { xs: "15px", sm: "20px" },
                          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                          borderRadius: "12px",
                          marginBottom: "30px",
                        }}
                      >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Box sx={{
                          width: { xs: "100%", md: "100%" },
                          padding: { xs: "15px", sm: "10px" },
                          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                          border: "2px solid rgb(224, 141, 64)",
                          marginY: { xs: "20px", sm: "30px" },
                          height: "auto",
                          marginLeft: { xs: "10px" }

                        }}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={2} xxl={2}>
                              <img
                                src={
                                  profile.profilePicture
                                    ? profile.profilePicture
                                    : "https://via.placeholder.com/168?text=No+Image"
                                }
                                alt={profile.name}
                                style={{
                                  width: '100%',
                                  height: '168px',
                                  borderRadius: "20px",
                                  objectFit: 'contain',
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={9}>
                              <Typography
                                sx={{ ...FontStyles.profilenameforcard }}
                              >
                                {profile.name}
                              </Typography>
                              <Typography
                                sx={{
                                  ...FontStyles.displayText

                                }}
                              >
                                {profile.displayText}
                              </Typography>

                              <Stack direction="row" flexWrap="wrap" gap={1} mb={1} >
                                <Button

                                  sx={{
                                    ...FontStyles.profileId
                                  }}
                                  onClick={() =>
                                    navigate(`/profile/ProfileView`, {
                                      state: { profileId: profile.id },
                                    })
                                  }
                                >
                                  AM101302
                                </Button>
                                <Button
                                  startIcon={
                                    <AccountCircleIcon
                                      sx={{
                                        width: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" },
                                        height: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" },
                                      }}
                                    />
                                  }
                                  sx={{
                                    ...styles.interstbuttonview,
                                  }}
                                  onClick={() =>
                                    navigate(`/profile/ProfileView`, {
                                      state: { profileId: profile.id },
                                    })
                                  }
                                >
                                  View Profile
                                </Button>

                                {/* <Button startIcon={<SendIcon sx={{ width: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" }, height: { xs: "auto", sm: "auto", md: "auto", lg: "30px", xl: "30px", xxl: "50px" } }} />}
                                  sx={{
                                    ...styles.interstbutton
                                  }}
                                  onClick={() => sendInterest(profile.id)}
                                >
                                  Send Interest
                                </Button>
                                <>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      ...FontStyles.accept
                                    }}
                                    onClick={() => getAccept(profile.id)}>
                                    Accept
                                  </Button>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      ...FontStyles.ignore
                                    }}
                                    onClick={() => getIGNORE(profile.id)}
                                  >
                                    Ignore
                                  </Button>
                                </> */}
                              </Stack>
                            </Grid>
                          </Grid>
                        </Box>

                      </Card>
                    ))}
                  </Box>
                )}

              </Grid>
            </Grid>
          )}
        </>
      </Box>
    </>
  );
};

export default ProfileCategories;

